export enum MaintenanceMonitoringStepsEnum {
  TICKET = "Chamado",
  SCREENING = "Triagem",
  REPAIR = "Reparo",
  INSPECTION = "Inspeção",
  RELEASE = "Liberação",
  FINISHED = "Finalizado",
}

export enum MaintenanceMonitoringStatusEnum {
  PENDING = "Não iniciado",
  IN_PROGRESS = "Em progresso",
  DONE = "Concluído",
  VALIDATION = "Avaliar",
}

export const MaintenanceMonitoringStepLabelIdMap: Record<keyof typeof MaintenanceMonitoringStepsEnum, string> = {
  TICKET: "intl-msg:shared.maintenanceMonitoring.step.ticket",
  SCREENING: "intl-msg:shared.maintenanceMonitoring.step.screening",
  REPAIR: "intl-msg:shared.maintenanceMonitoring.step.repair",
  INSPECTION: "intl-msg:shared.maintenanceMonitoring.step.inspection",
  RELEASE: "intl-msg:shared.maintenanceMonitoring.step.release",
  FINISHED: "intl-msg:shared.maintenanceMonitoring.step.finished",
};

export const MaintenanceMonitoringStatusLabelIdMap: Record<keyof typeof MaintenanceMonitoringStatusEnum, string> = {
  PENDING: "intl-msg:shared.maintenanceMonitoring.status.pending",
  IN_PROGRESS: "intl-msg:shared.maintenanceMonitoring.status.inProgress",
  DONE: "intl-msg:shared.maintenanceMonitoring.status.done",
  VALIDATION: "intl-msg:shared.maintenanceMonitoring.status.validation",
};
